export default function getScrollParent(el: HTMLElement | null): HTMLElement | null {
  if (!el) {
    return null;
  }

  return el.scrollHeight > el.clientHeight ? el : getScrollParent(el.parentElement);
}
